import {
    SET_STATES
} from './StatesType';


const reducers = (state = [], action: any) => {
    if (action.type === SET_STATES) {
        return {
            ...state,
            statesDropDownList: action.statesDropDownList,
        };
    }
    else {
        return state;
    }
}

export {
    reducers
}